import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable()
export class GetPreferenceInterceptorService implements HttpInterceptor {
	// TODO wkennerl: remove this interceptor when we're done with dismiss status
	public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		let response;
		if (req.url.includes('get-preference') && req.body['keys'] === 'BFA_FUND_STATUS_INTERACTIONS') {
			const data = require('../data/status-interactions-data.json');
			response = new HttpResponse({
				body: JSON.parse(JSON.stringify({
					preferenceKey: 'BFA_FUND_STATUS_INTERACTIONS',
					uniqueId: 'u7688142a60a6daef379a7c458a389f52@PREFERENCE@BFA_FUND_STATUS_INTERACTIONS',
					children: data
				}))
			});

			return of(response);
		} else {
			return next.handle(req);
		}
	}

}
